/* Stylesheet */

.content_page_wrapper {
  .wrapper_container {
    padding: 72px 0px 72px 0px;
    margin: 0 auto;
    width: 90%;
  }
}

@media screen and (min-width: 1200px) {
  .content_page_wrapper {
    .wrapper_container {
      width: 75%;
    }
  }
}
